import { PanelColor } from "../props";

export const panelBackgroundStyles: Record<PanelColor, string> = {
  level0: "bg-white dark:bg-[#070707]",
  level1: "bg-back-50 dark:bg-back-950",
  level2: "bg-back-100 dark:bg-back-900",
  level3: "bg-back-200 dark:bg-back-800",
  level4: "bg-back-300 dark:bg-back-700",
  level5: "bg-back-400 dark:bg-back-600",
  level6: "bg-back-500 dark:bg-back-500",
  level7: "bg-back-600 dark:bg-back-400",
  level8: "bg-back-700 dark:bg-back-300",
  level9: "bg-back-800 dark:bg-back-200",
  level10: "bg-back-900 dark:bg-back-100",
  level11: "bg-[#070707] dark:bg-white",
};

export const panelForegroundStyles: Record<PanelColor, string> = {
  level0: "text-front-900 dark:text-front-100",
  level1: "text-front-900 dark:text-front-100",
  level2: "text-front-900 dark:text-front-100",
  level3: "text-front-900 dark:text-front-100",
  level4: "text-front-900 dark:text-front-100",
  level5: "text-front-900 dark:text-front-100",
  level6: "text-front-100 dark:text-front-100",
  level7: "text-front-100 dark:text-front-900",
  level8: "text-front-100 dark:text-front-900",
  level9: "text-front-100 dark:text-front-900",
  level10: "text-front-100 dark:text-front-900",
  level11: "text-front-100 dark:text-front-900",
};

export const panelBorderStyles: Record<PanelColor, string> = {
  level0: "border-back-200 dark:border-back-700",
  level1: "border-back-100 dark:border-back-800",
  level2: "border-back-200 dark:border-back-700",
  level3: "border-back-300 dark:border-back-600",
  level4: "border-back-400 dark:border-back-500",
  level5: "border-back-500 dark:border-back-400",
  level6: "border-back-600 dark:border-back-300",
  level7: "border-back-700 dark:border-back-200",
  level8: "border-back-800 dark:border-back-100",
  level9: "border-back-900 dark:border-back-50",
  level10: "border-back-900 dark:border-back-100",
  level11: "border-back-800 dark:border-back-200",
};

export const panelHoverStyles: Record<PanelColor, string> = {
  level0: "hover:bg-white/10 dark:hover:bg-black/10",
  level1: "hover:bg-back-50/20 dark:hover:bg-back-950/20",
  level2: "hover:bg-back-100/20 dark:hover:bg-back-900/20",
  level3: "hover:bg-back-200/20 dark:hover:bg-back-800/20",
  level4: "hover:bg-back-300/20 dark:hover:bg-back-700/20",
  level5: "hover:bg-back-400/20 dark:hover:bg-back-600/20",
  level6: "hover:bg-back-500/20 dark:hover:bg-back-500/20",
  level7: "hover:bg-back-600/20 dark:hover:bg-back-400/20",
  level8: "hover:bg-back-700/20 dark:hover:bg-back-300/20",
  level9: "hover:bg-back-800/20 dark:hover:bg-back-200/20",
  level10: "hover:bg-back-900/20 dark:hover:bg-back-100/20",
  level11: "hover:bg-black/10 dark:hover:bg-white/10",
};

export function getPanelHoverStyles(color: PanelColor): string {
  return panelHoverStyles[color];
}
